import { render, staticRenderFns } from "./TokenRemoveCustom.vue?vue&type=template&id=26ab52b5&scoped=true"
import script from "./TokenRemoveCustom.vue?vue&type=script&lang=js"
export * from "./TokenRemoveCustom.vue?vue&type=script&lang=js"
import style0 from "./TokenRemoveCustom.vue?vue&type=style&index=0&id=26ab52b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ab52b5",
  null
  
)

export default component.exports